module.exports = __webpack_public_path__ + "img/scence2.ebc53e49.jpg";